{
  "community":{
    "instrument":"kalimba",
    "proverb":"if you want to go quickly, go alone. if you want to go far, go together.",
    "trees":[0,1],
    "worldmap":null,
    "index":0,
    "mlmprefix":"an upbeat West African kalimba melody with a playful beat ",
    "treesprefix":"the resonant rhythm of a West African djembe with drumbeats",
    "treeslowprefix":"calm dreamy West African percussions with drumbeats and djembe",
    "pondprefix":"gentle resonant West African percussions with a soothing melody",
    "floorprefix":"playful rhythm of the West African vibraphone with a clear steady vibrant melody",
    "cloudsprefix":"soft dreamy fluffy West African rhythms with flutes",
    "artworks":["go_far.png"],
    "benches":[48,138,344,249],
    "keywords":[
      {
         "keyword":"unity",
         "prompt":"with a positive harmony of the vibraphone",
         "riddle":false
      },
      {
         "keyword":"collaboration",
         "prompt":"with celebratory sounds of the shekere shaker",
         "riddle":false
      },
      {
         "keyword":"strength",
         "prompt":"with a strong drumbeat ",
         "riddle":false
      },
      {
         "keyword":"welcoming",
         "prompt":"with a welcoming sound",
         "riddle":false
      },
      {
         "keyword":"empowered",
         "prompt":"with an empowering and inspiring sound",
         "riddle":false
      },
      {
         "keyword":"hope",
         "prompt":"with a hopeful sound",
         "riddle":true
      },
      {
         "keyword":"trust",
         "prompt":"with a comforting sound",
         "riddle":true
      },
      {
         "keyword":"harmony",
         "prompt":"with a soothing calming harmony",
         "riddle":true
      },
      {
         "keyword":"celebration",
         "prompt":"with an upbeat celebratory  sound",
         "riddle":true
      }
    ],
    "dream-prompts":{
      "instruments":{
        "balafon":"a mellow West African balafon melody",
        "mbira":"a soft gentle West African mbira melody",
        "marimba":"a soft gentle West African marimba melody",
        "shekere":"resonant shaking melody of a West African shekere shaker",
        "slit drum":"deep resonant booming of a West African slit drum",
        "kora":"a gentle resonant drifting mellow West African kora melody",
        "dunun":"a resonant deep full rhythm of a West African dunun drum melody",
        "flute":"an airy West African flute melody",
        "agogo":"the resonant rhythm of a West African agogo cow bell melody",
        "bata":"the resonant rhythm of a West African bata drum melody",
        "omele":"the resonant rhythm of a West African omele drum  melody",
        "djembe":"the resonant rhythm of a West African djembe melody",
        "ngoni":"a mellow bluesy resonant West African ngoni melody ",
        "talking drum":"the resonant rhythm of a West African talking drum melody",
        "synthesizers":"the warm electronic beats of a synthesizer with a West African melody",
        "bass":"the low resonant deep rhythm of an electronic bass with a West African melody"
      },
      "colors":{
        "possibility":" with an inspiring emotional upbeat sound",
        "experimental":" with an experimental playful sound",
        "hopeful":" with a hopeful joyous sound",
        "joyful":" with a joyful happy beat",
        "risky":" with a suspensful evocative sound",
        "magical":" with a twinkling magical airy sound",
        "empowering":" with a strong moving inspiring bass sound",
        "creative":" with a playful light and creative sound",
        "playful": " with a playful sweet and silly sound",
        "mindful": " with a gentle calming sound",
        "wise": " with a comforting nostalgic sound",
        "reflective": " with a pensive meditative sound",
        "personal":" with an emotional positive sound",
        "optimism":" with an optimistic happy beat",
        "slow":" with a soft slow sound",
        "vibrant":" with an exciting vibrant sounds"
      }
    },
    "dream-prefix":""

  },
  "spirit":{
    "instrument":"bass",
    "proverb":"A tree does not move unless there is wind.",
    "trees":[2],
    "worldmap":"worldmap3_3",
    "index":1,
    "mlmprefix" : "resonant rhythm of a West African djembe and drumbeats ",
    "treesprefix":"with a resonant rhythm of a West African djembe and drumbeats",
    "treeslowprefix":"dreamy calm soft West African percussion band with slow calm drumbeats",
    "pondprefix":"with a gentle resonant West African percussion with soft and soothing melody",
    "floorprefix":"with a playful resonant rhythm of West African vibraphone with a clear steady vibrant melody",
    "cloudsprefix":"with a soft dreamy fluffly West African rhythms and flutes melody",
    "centertreeprefix":"with a gentle resonant West African percussion with a soft and soothing kora and tambin melody",
    "leafprefix":"with a West African flutes that sound like birds",
    "bridgeprefix":"with a rythmic repeating background beat with West African percussions",
    "artworks":["a_tree.png"],
    "benches":[277,217,249,167,103],
    "keywords":[
      {
         "keyword":"progress",
         "prompt":"with a progressive hopeful sound",
         "riddle":true
      },{
         "keyword":"grow",
         "prompt":"with a deep resonant drumming beat",
         "riddle":false
      },{
         "keyword":"energy",
         "prompt":"with an energetic sound",
         "riddle":false
      },{
         "keyword":"excitement",
         "prompt":"with an exciting sound ",
         "riddle":false
      },{
         "keyword":"bravery",
         "prompt":"with a resounding deep drumbeat sound",
         "riddle":true
      },{
         "keyword":"motivation",
         "prompt":"with a motivating happy sound",
         "riddle":true
      },{
         "keyword":"uplifting",
         "prompt":"with an upbeat drumbeat",
         "riddle":false
      },{
         "keyword":"happy",
         "prompt":"with a motivating happy sound",
         "riddle":false
      },{
         "keyword":"resilience",
         "prompt":"with a comforting sound",
         "riddle":true
      }
    ],
    "dream-prompts":{
      "instruments":{
        "balafon":"a mellow West African balafon melody",
        "mbira":"a soft gentle West African mbira melody",
        "marimba":"a soft gentle West African marimba melody",
        "shekere":"resonant shaking melody of a West African shekere shaker",
        "slit drum":"deep resonant booming of a West African slit drum",
        "kora":"a gentle resonant drifting mellow West African kora melody",
        "dunun":"a resonant deep full rhythm of a West African dunun drum melody",
        "flute":"airy West African flute melody",
        "agogo":"resonant rhythm of a West African agogo cow bell melody",
        "bata":"resonant rhythm of a West African bata drum melody",
        "omele":"resonant rhythm of a West African omele drum melody",
        "djembe":"resonant rhythm of a West African djembe melody",
        "ngoni":"mellow bluesy resonant West African ngoni melody",
        "talking drum":"resonant rhythm of a West African talking drum melody",
        "synthesizers":"warm electronic beats of a synthesizer with a West African melody",
        "bass":"low resonant deep rhythm of an electronic bass with a West African melody"
      },
      "colors":{
        "purple":" with a deep resonant beat",
        "blue":" with a serene calming harmony",
        "red":" with a powerful fast emotional beat",
        "orange":" with a vibrant warm harmony",
        "green" : " with earthy grounded beat",
        "yellow": " with a happy and warm beat",
        "pink":" with soft romantic harmonies"
      }
    },
    "dream-prefix":" "
  }
}
